module.exports = __webpack_public_path__ + "img/choco-shake-majuscules.95b26de1.jpg";